export const IMAGES = {
  logoLight: require("src/images/files/logo.png"),
  logoDark: require("src/images/files/logo-2.png"),
  login: require("src/images/files/login-bg.jpg"),
  noData: require("src/images/files/no-data.png"),
  empty: require("src/images/files/404.png"),
  signiture: require("src/images/files/sample-sign.png"),
};
